import { useFetchRequest } from '../../utils';
import ENDPOINTS from '../../endpoints';

export const useFetchData = () => {
  const teamListState = useFetchRequest(ENDPOINTS.getTeamList());

  return { teamListState };
};
